<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Alt Konum Güncelleme</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <form action="#">
      <label>Rol Adı</label>
      <div class="form-group">
        <input type="text" id="rolename" name="rolename" [(ngModel)]="roleName"
          placeholder="Güncellemek istediğiniz rol adını giriniz." class="form-control" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeModal()" rippleEffect>
      İptal
    </button>
    <button type="button" class="btn btn-primary" rippleEffect (click)="updateRole(roleName)">
      Güncelle
    </button>
  </div>